/*@custom*/
document.addEventListener('alpine:init', () => {
  Alpine.data('lineNote', () => ({
    lineNoteOpen: false,
    lineNote: '',
    isLoading: false,

    init() {
      this.loadExistingNote();
    },
    
    loadExistingNote() {
      const { noteValue } = this.$root.dataset;
      if (noteValue) {
        this.lineNote = noteValue;
      }
    },
    
    async saveNote() {
      this.startLoading();
      
      try {
        await this.removeLineQuantity();
        await this.addLineWithNote();
        
        if (this.$root.dataset.template !== 'cart') {
          this.refreshCartDrawer();
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Error saving note:', error);
      } finally {
        this.stopLoading();
      }
    },
    
    startLoading() {
      this.isLoading = true;
    },
    
    stopLoading() {
      this.isLoading = false;
    },
    
    refreshCartDrawer() {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    },
    
    closeNote() {
      if (!this.isLoading) {
        this.lineNoteOpen = false;
      }
    },
    
    removeNote() {
      this.lineNote = '';
      this.saveNote();
    },
    
    /**
     * Returns a promise that resolves when the line quantity is removed
     */
    async removeLineQuantity() {
      const key = this.$root.dataset.key;
      const quantity = parseInt(this.$root.dataset.quantity, 10);
      
      let updates = {};
      updates[key] = quantity - 1;
      
      const response = await this.makeCartRequest(
        theme.routes.cartUpdate,
        { updates }
      );
      
      if (!response.ok) throw new Error('Failed to update cart');
      return response.json();
    },
    
    /**
     * Returns a promise that resolves when the line is added with note
     */
    async addLineWithNote() {
      const variantId = this.$root.dataset.variantId;
      const formData = {
        'items': [
          {
            'quantity': 1,
            'id': variantId,
            'properties': {
              'note': this.lineNote
            }
          }
        ]
      };
      
      const response = await this.makeCartRequest(
        theme.routes.cartAdd,
        formData
      );
      
      if (!response.ok) throw new Error('Failed to add item with note');
      return response.json();
    },
    
    /**
     * Makes a standardized cart request to the Shopify API
     */
    async makeCartRequest(url, data) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    }
  }));
}); 